// 接口文档：http://confluence.mobvista.com/pages/viewpage.action?pageId=35005488#id-%E3%80%90%E5%90%8E%E7%AB%AF%E3%80%91DCO%E9%A1%B9%E7%9B%AE%E4%B8%80%E6%9C%9F-j%E3%80%81%E5%89%8D%E5%90%8E%E7%AB%AF%E5%AF%B9%E6%8E%A5

import _ from 'lodash'
import i18n from '@/lang'
import { MessageBox, Message } from 'element-ui'
import {
  getDmakerTemplateInfo,
  getDmakerBasicPackageInfo,
} from '@/api/creative/template'
import { getDmakerCustomInfo } from '@/api/creative/custom'
import {
  getGmakerBasicTplInfo,
  getGmakerTemplateInfo,
} from '@/api/gmaker/template'
import { getGmakerProjectInfo } from '@pt/api/gmaker/project'
import rebuildCategory from '../common/rebuild-category'
import cookJsonConfig from '../common/cook-json-config'
import { computeGameDifficulty } from '../common'
import cookPermissions from '../common/cook-permissions'
import generateGroupList from '@/views/creative/utils/generate-group-list'
import { cookResources, getDefaultResource } from '../common/resource'
import {
  categoryConfig,
  findCatgeory,
  isCameraCategory,
  isFeGameConfigCategory,
  isFePresetCategory,
  traverseCategory,
} from '../common/category'
import { workspaceSetting } from '@pt/utils/storage'
import { dotNotationToBracketNotation } from '@com/utils/string'
import { engineType } from '@/store/creative/template/config'
import checkJsonConfigForbiddenFont from '@/utils/checkJsonConfigForbiddenFont'
import { dealPtVersionI18n } from '@/utils/checkJsonConfigForbiddenFont'
import generatePresetCategory, {
  generatePresetConfig,
} from '@/views/creative/utils/generate-preset-category'
import { isPlayAgain } from '@/views/creative/utils'
import isMaterialWarehouse from '@/common/is-warehouse.js'
import { isAnimationPrefix } from '@/views/creative/utils'

/**
 * playConfig 用于存储玩法的标题描述
 */
function cookPlayConfig({ playConfig, jsonConfig, ext_editor_config }) {
  playConfig =
    playConfig && _.isString(playConfig) ? JSON.parse(playConfig) : playConfig

  // play_config 有值
  if (!_.isEmpty(playConfig)) {
    // https://confluence.mobvista.com/pages/viewpage.action?pageId=62719629 需求之前的旧数据，将旧数据转换成新数据格式
    const hasOldData = _.isArray(playConfig)
    if (hasOldData) {
      const config = {
        gameConfig: {
          // 将玩法在 gameConfig.json 中的访问路径作为 key
          // key: {
          //   name: 'name',
          //   name_en: 'name_en',
          //   desc: 'desc',
          //   desc_en: 'desc_en'
          // }
        },
      }
      playConfig = playConfig.filter((item) => {
        // 过滤不必要的的异常数据（这几个分类配置每次重新生成即可，不用存储到服务端）
        return [
          categoryConfig.gameConfigStars.id,
          categoryConfig.globalClick.id,
          categoryConfig.ydClick.id,
          categoryConfig.autoClick.id,
          categoryConfig.autoEndTime.id,
        ].every((j) => j !== item.id)
      })
      traverseCategory(
        {
          sub_category: playConfig.filter(
            // colorConfig 不需要
            (item) => item.prefix !== categoryConfig.colorConfig.id,
          ),
        },
        (category) => {
          if (category.id) {
            const path = dotNotationToBracketNotation(category.id)
            const name = category.name || ''
            const nameEn = category.name_en || category.name
            config.gameConfig[path] = {
              name,
              name_en: nameEn,
              desc: category.desc || name,
              desc_en: category.desc_en || category.desc || nameEn || name,
            }
          }
        },
      )
      return config
    }

    // 是对象，则直接返回
    const hasNewData = _.isPlainObject(playConfig)
    if (hasNewData) {
      let editorConfig = {}
      if (ext_editor_config) {
        try {
          editorConfig = JSON.parse(ext_editor_config)
          // 如果 editorConfig 不为空，并且之前没有存储过，则将 editorConfig 存储到 playConfig 中
          if (
            !_.isEmpty(editorConfig) &&
            typeof playConfig.editorConfig === 'undefined'
          ) {
            playConfig.editorConfig = editorConfig
          }
        } catch (e) {
          console.error('获取到的 editorConfig 不是一个常规字符串', e)
        }
      }
      return playConfig
    }
  }

  // playConfig 为空根据 gameConfig 生成
  const rec = (data, path, cb) => {
    _.each(data, (item, key) => {
      cb(item, [...path, key])
      if (item.items) {
        rec(item.items, [...path, key, 'items'], cb)
      }
    })
  }
  let editorConfig = {}
  if (ext_editor_config) {
    try {
      editorConfig = JSON.parse(ext_editor_config)
    } catch (e) {
      console.error('获取到的 editorConfig 不是一个常规字符串', e)
    }
  }
  const config = {
    gameConfig: {},
    editorConfig: editorConfig,
  }
  rec(jsonConfig.gameConfig, [], (data, paths) => {
    const path = paths.map((item) => `[${item}]`).join('')
    const name = data.title || data.desc || ''
    const desc = data.desc || data.title || ''
    config.gameConfig[path] = {
      name,
      name_en: name,
      desc,
      desc_en: desc,
    }
  })
  return config
}

/**
 * cookApiParamsPath
 * @param {{id: number, page: string}} param0
 * name：该路由名字
 */
export function cookApiParams({
  id,
  page,
  isPreviewBasicPackage,
  basicId,
  skinId,
  templateType,
}) {
  // 通用模板制作
  const getCommonTemplateProject = () => {
    return {
      params: {
        project_id: id,
      },
      request: getGmakerProjectInfo,
    }
  }
  const commonTemplateCustomApiUtils = {
    'common-template-dco': getCommonTemplateProject,
    'common-template-custom': getCommonTemplateProject,
    'common-template-multi-custom': getCommonTemplateProject,
  }

  // 定制模板制作（普通/dco/多组合制作）
  // 素材仓库与 pt 有普通和 dco 制作，pt 才有多组合制作功能
  const templateCustomApiUtils = {
    custom: () => {
      return {
        params: {
          custom_id: id,
        },
        request: getDmakerCustomInfo,
      }
    },
  }

  // 模板编辑
  const templateApiUtils = {
    template: () => {
      // 模板配置预览
      if (isPreviewBasicPackage) {
        if (templateType === 'gm') {
          return {
            params: {
              tpl_id: id,
              basic_id: basicId,
            },
            request: getGmakerBasicTplInfo,
          }
        }
        return {
          params: {
            tpl_id: id,
            basic_id: basicId,
          },
          request: getDmakerBasicPackageInfo,
        }
      }

      return {
        params: {
          template_id: id,
        },
        request: getDmakerTemplateInfo,
      }
    },

    'common-template': () => {
      return {
        params: {
          template_id: id,
          skin_id: skinId,
        },
        request: getGmakerTemplateInfo,
      }
    },
  }

  const apiUtils = {
    ...templateApiUtils,
    ...templateCustomApiUtils,
    ...commonTemplateCustomApiUtils,
  }

  return apiUtils[page]() || null
}

function getWorkSpaceSettingFromCache() {
  return workspaceSetting.get()
}

// eslint-disable-next-line space-before-function-paren
export default async function (
  { commit, state, dispatch, rootState },
  params = {},
) {
  const apiParams = cookApiParams({
    page: state.page,
    id: state.id,
    isPreviewBasicPackage: state.isPreviewBasicPackage,
    basicId: state.basicId,
    skinId: state.skinId,
    templateType: state.templateType,
  })

  if (!apiParams) {
    Message({
      message: 'Fail to get template',
      type: 'error',
      duration: 5 * 1000,
    })
    return
  }

  let res = {}
  try {
    console.log(apiParams.params)
    res = await apiParams.request(apiParams.params)
  } catch (e) {
    MessageBox.confirm(e.message || 'Failed to get template info', 'Error', {
      confirmButtonText: 'Refresh',
      cancelButtonText: 'Cancel',
    }).then(() => {
      window.location.reload()
    })
  }

  // todo: 保存模板后要重新获取模板信息，暂时使用回调函数的方式处理
  if (_.isFunction(params.afterRequest)) {
    params.afterRequest(res)
    return
  }

  // 工具配置
  const workSpaceSetting = getWorkSpaceSettingFromCache()
  if (workSpaceSetting) {
    state.workSpaceSetting = {
      ...state.workSpaceSetting,
      ...workSpaceSetting,
    }
  }

  // 接口判断
  if (_.get(res, 'data.code') !== 0) return

  const info = _.get(res, 'data.data') || {}
  commit('updateReadonly', info.readonly || false)
  // 素材包配置规范版本
  commit('updateVersion', info.spec_ver || 2)

  // 支持实时预览
  if (info.is_live_preview === 1) {
    commit('updateCanLivePreview', true)
  }

  // 如果含有 bind_demand 字段，则代表是绑定需求的版本
  if (info.bind_demand) {
    commit('updateBindDemand', info.bind_demand)
  }

  // 如果素材有 mvPlayable 设置状态
  if (info.mv_playable) {
    commit('updateMvPlayableState', true)
  }

  // 青瓷引擎制作的素材
  if (
    [engineType.playsmart, engineType.qc, engineType.playsmart2].includes(
      info.engine_type,
    )
  ) {
    state.isQcEngine = true
  }
  // cocos 引擎制作的素材
  if (info.engine_type === engineType.Cocos) {
    state.isCocosEngine = true
  }

  commit(
    'updatePermissions',
    cookPermissions({
      page: state.page,
      isPreviewBasicPackage: state.isPreviewBasicPackage,
      roles: rootState.user.roles,
      // mock
      version: state.version,
      isQcEngine: state.isQcEngine,
    }),
  )

  // 序列化 json config
  if (info.json_config) {
    commit('updateHasJsonConfig', true)
    try {
      // 有些时候 mock 数据是 JSON 对象，不需要 parse
      info.json_config = _.isString(info.json_config)
        ? JSON.parse(info.json_config)
        : info.json_config
    } catch (e) {
      info.json_config = {}
      throw new Error(i18n.t('playTurbo.creative.store.error1'))
    }
  } else {
    commit('updateHasJsonConfig', false)
    info.json_config = {}
  }

  if (info.skin_id) {
    commit('updateSkinId', info.skin_id)
  }

  // 收藏
  if (info.stars_config) {
    try {
      commit(
        'initStars',
        _.isString(info.stars_config)
          ? JSON.parse(info.stars_config)
          : info.stars_config,
      )
    } catch (e) {
      console.error(e)
      commit('initStars', {})
    }
  } else {
    commit('initStars', {})
  }

  // play_config 专门用于存储玩法的分类信息，如标题描述, 新增 自定义事件以及动画
  info.play_config = cookPlayConfig({
    playConfig: info.play_config,
    jsonConfig: info.json_config,
    ext_editor_config: info.ext_editor_config,
  })

  const gameConfig = _.get(info, 'json_config.gameConfig')
  if (gameConfig) {
    // compute difficulty mode
    // 由于需求方与产品多次改动需求，导致有多种难度模式有多种配置格式，所以需要先计算 gameDifficulty
    commit('updateGameDifficulty', computeGameDifficulty(gameConfig))
  }

  // 优先使用前端配置分类，无前端分类使用默认分类
  const feCategoryConfig =
    info.category_config && info.category_config.length
      ? info.category_config
      : info.category

  // 原始分类中的预设分类
  const originPresetCategory = findCatgeory(
    {
      sub_category: info.category,
    },
    (cat) => {
      return cat.id === categoryConfig.preset.id
    },
  )

  let presetConfig = {}
  // 如果含有原始分类中的预设分类，说明当前素材是预设素材
  if (originPresetCategory && originPresetCategory.sub_category) {
    commit('updateHasPresetResource', true)
    // 判断是否已经生成预设分类
    const hasInitPresetConfigCategory = !_.isEmpty(
      findCatgeory(
        {
          sub_category: feCategoryConfig,
        },
        (cat) => {
          return isFePresetCategory(cat)
        },
      ),
    )
    /**
     * 以下几种情况需要重新生成 presetConfig
     * 1. 如果 json_config 里面没有 presetConfig
     * 2. 如果 json_config 里面有 presetConfig，但是非前端生成的
     *    a. 前端生成的会有 type 以及 mw_mapping_path 字段
     */
    if (
      info.json_config &&
      (_.isEmpty(info.json_config.presetConfig) ||
        (info.json_config.presetConfig &&
          !_.some(info.json_config.presetConfig, (config) => {
            return config.type && config.mw_mapping_path
          })))
    ) {
      presetConfig = generatePresetConfig(
        originPresetCategory.sub_category,
        info.json_config.presetConfig,
      )
    }

    if (!hasInitPresetConfigCategory) {
      const presetCategory = generatePresetCategory(
        originPresetCategory.sub_category,
      )
      const targetCategory = findCatgeory(
        {
          sub_category: feCategoryConfig,
        },
        (cat) => {
          return cat.id === categoryConfig.preset.id
        },
      )
      targetCategory.sub_category = presetCategory
    }
  }

  // 提取 modelModifyConfig 的数据到模型的 store 里面
  if (info.json_config && !_.isEmpty(info.json_config.modelModifyConfig)) {
    this.commit(
      'creative/modelEditor/setModifyConfig',
      info.json_config.modelModifyConfig,
    )
  }

  // 提取 cameraAdaptConfig 的数据到模型的 store 里面
  if (info.json_config && !_.isEmpty(info.json_config.cameraConfig)) {
    this.commit(
      'creative/modelEditor/setCameraAdaptConfig',
      info.json_config.cameraConfig,
    )
    const hasInitCameraConfigCategory = !_.isEmpty(
      findCatgeory(
        {
          sub_category: feCategoryConfig,
        },
        (cat) => {
          return isCameraCategory(cat)
        },
      ),
    )
    if (!hasInitCameraConfigCategory) {
      const presetCategory = findCatgeory(
        {
          sub_category: feCategoryConfig,
        },
        (cat) => {
          return cat.id === categoryConfig.preset.id
        },
      )
      // 如果是没有预设，但是有镜头配置，sub_category 为空, 需要初始化
      if (presetCategory && !presetCategory.sub_category) {
        presetCategory.sub_category = []
      }
      // 如果cameraConfig内adapt.adaptDatas无数据，屏幕适配不展示
      const hasAdaptData =
        rootState.creative.modelEditor.cameraAdaptConfig.adapt &&
        rootState.creative.modelEditor.cameraAdaptConfig.adapt.adaptDatas
          ? rootState.creative.modelEditor.cameraAdaptConfig.adapt.adaptDatas
              .length
          : 0
      if (
        presetCategory &&
        presetCategory.sub_category &&
        Array.isArray(presetCategory.sub_category) &&
        hasAdaptData
      ) {
        presetCategory.sub_category.push({
          pid: presetCategory.id,
          id: -1,
          name: '屏幕适配',
          name_en: '屏幕适配',
          prefix: '3DScreen',
          resource_type: '3DScreenConfig',
        })
      }
      // 如果cameraConfig内orbitParams无数据，相机不展示
      const hasOrbitParams = rootState.creative.modelEditor.cameraAdaptConfig
        .orbitParams
        ? rootState.creative.modelEditor.cameraAdaptConfig.orbitParams.length
        : 0
      if (
        presetCategory &&
        presetCategory.sub_category &&
        Array.isArray(presetCategory.sub_category) &&
        hasOrbitParams
      ) {
        presetCategory.sub_category.push({
          pid: presetCategory.id,
          id: -2,
          name: '相机',
          name_en: '相机',
          prefix: '3DScene',
          resource_type: '3DSceneConfig',
        })
      }
    }
  }

  // 可以找到前端生成的玩法分类，说明玩法已经被生成过
  // 已经生成category_config中的玩法分类，认为玩法已经被生成过(20220721)
  const hasInitGameConfigCategory =
    !_.isEmpty(
      findCatgeory(
        {
          sub_category: feCategoryConfig,
        },
        (cat) => {
          return isFeGameConfigCategory(cat)
        },
      ),
    ) ||
    (info.category_config &&
      info.category_config.length &&
      info.category_config.find((item) => item.id === 3) &&
      info.category_config.find((item) => item.id === 3).sub_category &&
      info.category_config.find((item) => item.id === 3).sub_category.length)
  const hasInitPlayAgainCategory = !_.isEmpty(
    findCatgeory(
      {
        sub_category: feCategoryConfig,
      },
      (cat) => {
        return isPlayAgain(cat.id)
      },
    ),
  )
  // json config
  if (info.json_config) {
    const {
      jsonConfig,
      gameConfigResource,
      currentLanguage,
      i18nResource,
      languages,
    } = cookJsonConfig({
      jsonConfig: info.json_config,
      hasInitGameConfigCategory,
      // dco config，dco 制作才有 dco_config 配置
      dcoConfig: null,
      gameDifficulty: state.gameDifficulty,
      editorConfig: info.editor_config,
      page: state.page,
      isMultiCustom: state.isMultiCustom,
      isDco: false,
      category: feCategoryConfig || [],
      presetConfig: presetConfig,
    })
    // 通用模版才有自定义字体
    const assetFontList = state.isCommonTemplateCustom
      ? rootState.assets.resource.assetFontList
      : []
    // 检查是否包含下架字体
    const { status, forbiddenList } = await checkJsonConfigForbiddenFont(
      dealPtVersionI18n(i18nResource),
      rootState.config.fontList,
      assetFontList,
    )
    // 一键替换下架字体
    if (status) {
      this.commit('creative/forbiddenFont/updateForbiddenFontDialog', {
        visible: true,
        forbiddenFontList: forbiddenList,
        fontOptions: rootState.config.fontList.concat(assetFontList),
        assetFontConfig: { list: state.isCommonTemplateCustom },
      })
    }
    info.json_config = jsonConfig

    if (currentLanguage) {
      commit('updateCurrentLanguage', currentLanguage)
      // 获取模板后将当前预览语言与当前语言一致
      commit('updatePreviewLanguage', currentLanguage)
    }

    // 玩法配置，用于在有关联场景/组/资源的玩法使用
    gameConfigResource && commit('updateGameConfigResource', gameConfigResource)
    i18nResource && commit('updateI18nResource', i18nResource)
    languages && commit('updatePreviewLanguageList', languages)
  }

  if (info.supported_mw_configs) {
    info.supported_mw_configs = info.supported_mw_configs
      ? info.supported_mw_configs.split(',')
      : null
  }

  // 根据 supported_mw_configs 产出对应数据
  const cookMwConfig = ({ supported_mw_configs, mw_config }) => {
    if (_.isEmpty(supported_mw_configs)) {
      return null
    }
    const mwConfig = mw_config ? JSON.parse(info.mw_config) : {}
    supported_mw_configs.forEach((key) => {
      // 如果支持某特性，但是mwConfig中没有对应的值，则添加默认值，有则不处理
      if (_.isUndefined(mwConfig[key])) mwConfig[key] = 1
    })
    return mwConfig
  }
  info.mw_config = cookMwConfig(info)

  // stage_config
  if (info.stage_config) {
    try {
      info.stage_config = JSON.parse(info.stage_config)
    } catch (e) {
      info.stage_config = null
    }
  }

  /**
   * 计算组合信息
   * @param info {{}}
   * @returns {[]|any|string|string|*[]}
   */
  const cookGroupsConfig = ({ info }) => {
    return generateGroupList({
      resource: info.resource,
      i18nResource: state.i18nResource,
      gameConfigResource: state.gameConfigResource,
      templateConfig: info,
      state,
    })
  }

  if (info.resource) {
    const loseModel = []
    info.resource = cookResources(info.resource, (resource) => {
      // 判断是否含有模型资源
      if (
        resource.sub_resource_type === '3DModel' ||
        resource.sub_resource_type === '3DModelCocos'
      ) {
        commit('updateHasModelResource', true)
        if (resource.sub_resource_type === '3DModelCocos') {
          commit('updateHasCocosModel', true)
        }
        if (
          (!resource.extra ||
            (resource.extra && JSON.parse(resource.extra).in_system !== 1)) &&
          !isAnimationPrefix(resource.prefix) &&
          !resource.prefix.includes(':')
        ) {
          loseModel.push(resource.prefix)
        }
      }
    })
    if (loseModel.length && isMaterialWarehouse()) {
      Message({
        duration: 0,
        showClose: true,
        message: `3D模型 ${loseModel.join(
          '; ',
        )} 未上传到资源库，模板将不展示对应资源。`,
        type: 'warning',
      })
    }
  }

  const groupsConfig = await cookGroupsConfig({ info })
  await dispatch('updateGroupsConfig', groupsConfig)
  // category
  info.category = rebuildCategory({
    category: feCategoryConfig || [], // category_config
    hasInitGameConfigCategory,
    resource: info.resource,
    jsonConfig: info.json_config || null,
    page: state.page,
    commit,
    playConfig: info.play_config,
    starsConfig: state.starsConfig,
    gameDifficulty: state.gameDifficulty,
    isMultiCustom: state.isMultiCustom,
    gameConfigResource: state.gameConfigResource,
    i18nResource: state.i18nResource,
    mwConfig: info.mw_config,
    supportedMwConfigs: info.supported_mw_configs,
    enableGameConfig: info.enable_gameconfig,
    permissionKeys: state.permissions,
    hasInitPlayAgainCategory,
  })

  commit('updateTemplateConfig', info)

  if (state.canLivePreview) {
    // 存储当前预览的资源
    state.currentLivePreviewResource = getDefaultResource(
      _.get(state, 'templateConfig.resource') || {},
      _.get(state, 'templateConfig.category') || {},
    )
  }

  // 更新组合需要放在 updateTemplateConfig 之后
  if (_.get(state, 'groupsConfig[0].name')) {
    commit('updatePreviewGroupConfig', _.get(state, 'groupsConfig[0].name'))
  } else {
    console.error('组合解析错误')
    throw new Error('Template parsing error')
  }

  // 计算 outline category 信息，依赖的信息比较多，放在最后处理
  commit('updateOutlineCategory')
}
